<template>
  <v-card>
    <v-toolbar>
      <v-icon>wifi</v-icon>
      <v-toolbar-title>{{$t('network-wlan0-list')}}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon dark color="blue" @click="fetchWiFi()"><v-icon>sync</v-icon></v-btn>
    </v-toolbar>

    <v-card-text>
      <v-list two-line>
        <v-list-tile v-for="item in wifi_list" :key="item.name" @click="onConnectClick(item)">
          <v-list-tile-action>
            <v-progress-circular indeterminate v-if="scanning"></v-progress-circular>
            <v-badge :color="signalColorFromWifi(item)" overlap left v-else>
              <template v-slot:badge>
                <span>{{item.quality}}</span>
              </template>
              <v-list-tile-action>
                <v-icon large>wifi</v-icon>
              </v-list-tile-action>
            </v-badge>
          </v-list-tile-action>
          <!--CAMPO CENTRALE ***INIZIO*** - VISUALIZZAZIONE NOME WIFI-->
          <v-list-tile-content v-if="!('status' in item)">
            <v-list-tile-title v-text="item.name"></v-list-tile-title>
            <v-list-tile-sub-title>
              <span
                v-for="(pass, p) in item.passes"
                :key="p"
              >{{`Protocol: ${pass.protocol}, Cipher: ${pass.cipher}, Group Cipher: ${pass.group_cipher}`}}</span>
            </v-list-tile-sub-title>
          </v-list-tile-content>
          <!--CASO IN CUI SI STA INSERENDO LA PASSWORD-->
          <v-list-tile-content v-else-if="item.status.text=='password'">
            <v-list-tile-title v-text="$t('network-connection-insert-password', {ssid: item.name})"></v-list-tile-title>
            <v-list-tile-sub-title>
              <v-form v-model="item.status.valid" @submit.prevent="onConnectClick(item)">
                <v-text-field
                  label="Password"
                  v-model="item.status.password"
                  autofocus
                  :append-icon="item.status.show ? 'visibility' : 'visibility_off'"
                  :rules="[rules.required, rules.min]"
                  :type="item.status.show ? 'text' : 'password'"
                  @click:append="item.status.show = !item.status.show"
                ></v-text-field>
              </v-form>
            </v-list-tile-sub-title>
          </v-list-tile-content>
          <!--CASO IN CUI LA CONNESSIONE E' ANDATA A BUON FINE-->
          <v-list-tile-content v-else-if="item.status.text=='connecting'">
            <v-list-tile-title>{{$t('network-connection-connecting', {ssid: item.name})}}</v-list-tile-title>
          </v-list-tile-content>
          <!--CASO IN CUI LA CONNESSIONE E' ANDATA A BUON FINE-->
          <v-list-tile-content v-else-if="item.status.text=='success'">
            <v-list-tile-title>{{$t('network-connection-succesfull', {ssid: item.name})}}</v-list-tile-title>
          </v-list-tile-content>
          <!--CASO IN CUI LA CONNESSIONE NON E' ANDATA A BUON FINE-->
          <v-list-tile-content v-else-if="item.status.text=='failed'">
            <v-list-tile-title>{{$t('network-connection-failed', {ssid: item.name})}}</v-list-tile-title>
          </v-list-tile-content>
          <!--CAMPO CENTRALE ***FINE***-->

          <!--SE COMPARE LA STESSA WIFI A CUI SONO COLLEGATO-->
          <v-list-tile-action v-if="item.name == network.wlan0_current_ssid">
            <v-btn icon>
              <v-icon color="green">done</v-icon>
            </v-btn>
          </v-list-tile-action>
          <!--SE NON SONO IN FASE DI CONNESSIONE-->
          <v-list-tile-action v-else-if="!('status' in item) || item.status.text == 'password'">
            <v-btn icon>
              <v-icon>repeat</v-icon>
            </v-btn>
          </v-list-tile-action>
          <v-list-tile-action v-else-if="item.status.text == 'connecting'">
            <v-progress-circular indeterminate color="blue"></v-progress-circular>
          </v-list-tile-action>
          <v-list-tile-action v-else-if="item.status.text == 'success'">
            <v-btn icon>
              <v-icon color="green">done</v-icon>
            </v-btn>
          </v-list-tile-action>
          <v-list-tile-action v-else-if="item.status.text == 'failed'">
            <v-btn icon>
              <v-icon color="red">close</v-icon>
            </v-btn>
          </v-list-tile-action>
        </v-list-tile>
      </v-list>
    </v-card-text>
  </v-card>
</template>
<script>
import { Utils } from "@/common/api.service";
import { mapGetters } from "vuex";
import Vue from "vue";
import {
  FETCH_NETWORK_WIFI_LIST,
  NETWORK_WIFI_CONNECT
} from "../store/actions.type";

export default {
  name: "NetworkSettingsWifiList",
  data: () => ({
    rules: {
      required: value => !!value || "Required.",
      min: v => v.length >= 8 || "Min 8 characters"
    }
  }),
  mounted() {
    this.fetchWiFi();
  },
  computed: {
    ...mapGetters(["network", "wifi_list", "loading", "scanning"])
  },
  methods: {
    onConnectClick(wifi) {
      console.log(wifi);
      if (!("status" in wifi)) {
        //Vue.set(wifi, "insertPassword", true);
        Vue.set(wifi, "status", {
          text: "password",
          show: false, //show password
          valid: false, //validation for password
          password: "" //text password
        });
        //console.log(this.$refs);
        //this.$refs.inputPassword.focus();
      } else if (wifi.status.text == "password" && wifi.status.valid) {
        this.connectWifi(wifi);
      } else if (
        wifi.status.text == "success" ||
        wifi.status.text == "failed"
      ) {
        Vue.delete(wifi, "status");
      }
    },
    fetchWiFi() {
      this.$store.dispatch(FETCH_NETWORK_WIFI_LIST);
    },
    async connectWifi(wifi) {
      console.log(wifi);
      wifi.status.text = "connecting";

      const result = await this.$store.dispatch(NETWORK_WIFI_CONNECT, {
        ssid: wifi.name,
        password: wifi.status.password
      });
      console.log(result);
      //this.insertPassword = false;
      //wifi.insertPassword = false;
      if (result.ssid == wifi.name) {
        //this.connectionSuccesfull = true;
        //Vue.set(wifi, "connectionSuccesfull", true);
        //wifi.connectionSuccesfull = true;
        wifi.status.text = "success";
      } else {
        //wifi.connectionFailed = true;
        //Vue.set(wifi, "connectionFailed", true);
        wifi.status.text = "failed";
      }
    },
    signalColorFromWifi(wifi) {
      if (wifi.quality > 20) return "green";
      return "orange";
    },
    signalIconFromWifi(wifi) {
      //console.log(wifi.quality);
      if (wifi.quality > 25) return "signal_wifi_4_bar";
      if (wifi.quality > 20) return "signal_wifi_3_bar";
      if (wifi.quality > 15) return "signal_wifi_2_bar";
      if (wifi.quality > 10) return "signal_wifi_1_bar";
      if (wifi.quality !== null) return "signal_wifi_0_bar";
      return "signal_wifi_off";
    }
  }
};
</script>

